import { STATUS_LABELS, STATUS_CLASSES } from "@/lib/formatters";

export function StatusBadge({ status }) {
  return (
    <span
      data-testid={`status-badge-${status?.toLowerCase()}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border ${STATUS_CLASSES[status] || "status-draft"}`}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}
